import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ReviewableItem @reviewable={{this.reviewable}} />",{ moduleName: "discourse/templates/review-show.hbs" })